import { RentManagerConnectForm } from './RentManagerConnectForm'
import type { VendorConnectorProps } from './types'

export function RentManagerConnector({
  onConnected,
  onCancel,
}: VendorConnectorProps) {
  return (
    <RentManagerConnectForm
      onConnected={() => onConnected?.()}
      onCancel={() => onCancel?.()}
    />
  )
}
